import React, {Component} from "react"
import {checkCouponCode, get_premium_history, purchase_premium} from "../actions/premium";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import {withRouter} from "react-router-dom";
import withStyles from "@mui/styles/withStyles";
import {connect} from "react-redux";
import {
    Box,
    Button,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import LockIcon from '@mui/icons-material/Lock';
import validator from 'validator'
import SnackbarMessage from "./Custom/SnackbarMessage";
import visa from "../images/gopay/visa.png"
import verified_by_visa from "../images/gopay/verified_by_visa.png"
import mastercard_secure from "../images/gopay/mastercard_secure.png"
import mastercard_ele from "../images/gopay/mastercard_ele.png"
import mastercard from "../images/gopay/mastercard.png"
import maestro from "../images/gopay/maestro.png"
import electron from "../images/gopay/electron.png"
import PrivacyPolicy from "./Dialogs/PrivacyPolicy";
import TermsOfService from "./Dialogs/TermsOfService";
import {ShoppingCart} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import {clamp} from "../utilities/clamp";

import countries from "../utilities/countries.json"

const styles = {
    paper: {
        margin: 15,
        padding: 15,
    },
    backBtn: {
        marginTop: 15,
        marginLeft: 15,
    },
    payButton: {
        marginTop: 20
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
    redirectInfo: {
        color: "#969696",
        marginRight: 15
    },
    pay_logo: {
        height: 24,
        marginRight: 10
    },
    pay_logos: {
        display: "flex",
        flexWrap: "wrap",
        marginRight: 20,
        padding: "10px  0"
    },
    spanLink: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    no_vat: {
        color: "#f50057"
    },
    font: {
        fontSize: 16
    },

    root: {
        marginTop: 15,
        marginLeft: 15,
        marginRight: 15,
        minHeight: "calc(100vh - 86px)",
        position: "relative"
    }
};

class Premium extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect_url: null,
            iframe_url: null,
            iframe_ref: null,
            iframe_white_block_visible: false,
            privacyPolicyOpened: false,
            termsOfServiceOpened: false,
            //duration: props.match.params.type === "month" ? 30 : 365,
            duration: 365,
            tier: props.match.params.type === "lite" ? "lite" : "great",
            pay_clicked: false,
            fields: {
                first_name: "",
                last_name: "",
                email: "",

                street: "",
                city: "",
                postal_code: "",
                country_code: "SVK",  // https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
                phone_number: "",

                streetTouched: false,
                cityTouched: false,
                postal_codeTouched: false,
                country_codeTouched: false,
                phone_numberTouched: false
            },
            coupon: {
                code: "",
                type: null,
                value: null,
                errors: null
            },
            errors: {}
        }
    }

    componentDidMount() {
        this.props.get_premium_history();
        this.setState({
            ...this.state,
            fields: {
                ...this.state.fields,
                first_name: this.props.auth.user.first_name,
                last_name: this.props.auth.user.last_name,
                email: this.props.auth.user.email,
                street: this.props.auth.user.street || "",
                city: this.props.auth.user.city || "",
                postal_code: this.props.auth.user.postal_code || "",
                country_code: this.props.auth.user.country_code || "",
                phone_number: this.props.auth.user.phone_number || "",
            }
        });

        if (window.addEventListener) {
            window.addEventListener("message", this.onTrustpayMessage.bind(this), false);
        } else if (window.attachEvent) {
            window.attachEvent("onmessage", this.onTrustpayMessage.bind(this), false);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.type !== this.props.match.params.type) {
            this.setState({
                //duration: this.props.match.params.type === "month" ? 30 : 365
                tier: props.match.params.type === "lite" ? "lite" : "great"
            });
        }
    }

    purchase() {
        if (!this.isPayValid()) {
            this.setState({
                ...this.state,
                fields: {
                    ...this.state.fields,
                    streetTouched: true,
                    cityTouched: true,
                    postal_codeTouched: true,
                    country_codeTouched: true,
                    phone_numberTouched: true
                }
            });
        } else {
            this.setState({
                ...this.state,
                pay_clicked: true
            });
            this.props.purchase_premium(this.state.fields.street, this.state.fields.city, this.state.fields.postal_code, this.state.fields.country_code, this.state.fields.phone_number, this.state.duration, this.state.tier, this.state.coupon.type ? this.state.coupon.code : null)
                .then(res => {
                    if ("redirect_url" in res.data) {
                        this.setState({
                            ...this.state,
                            redirect_url: res.data.redirect_url
                        });
                    } else {
                        if (res.data.iframe_url === false) {
                            this.props.get_premium_history();
                            this.props.get_user_info();
                            this.props.history.push('/premium');
                        } else {
                            this.setState({
                                ...this.state,
                                iframe_url: res.data.iframe_url
                            });
                        }
                    }
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        pay_clicked: false,
                        errors: err.response.data.errors
                    });

                });
        }
    }

    isStreetInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.fields.streetTouched) return false;
        if (this.state.fields.street.length < 3) return "Invalid street format";
        return false;
    }

    isCityInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.fields.cityTouched) return false;
        if (this.state.fields.city.length < 3) return "Invalid city format";
        return false;
    }

    isCountryInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.fields.country_codeTouched) return false;
        if (this.state.fields.country_code.length < 3) return "Country is required";
        return false;
    }

    isPostalCodeInvalid(ignoreTouch = false) {
        if (!ignoreTouch && !this.state.fields.postal_codeTouched) return false;
        if (this.state.fields.postal_code.length < 3) return "Invalid postal code format";
        return false;
    }

    isPhoneNumberInvalid(ignoreTouch = false) {
        //if (!ignoreTouch && !this.state.fields.phone_numberTouched) return false;
        if (this.state.fields.phone_number.trim().length > 0) {
            if (!validator.isMobilePhone(this.state.fields.phone_number)) return "Invalid phone number format";
            return false;
        } else return false;
    }

    isPayValid() {
        return !this.isStreetInvalid(true) && !this.isCityInvalid(true) && !this.isCountryInvalid(true) && !this.isPostalCodeInvalid(true) && !this.isPhoneNumberInvalid(true);
    }

    onFieldChange(e) {
        const name = e.target.name === "country" ? "country_code" : e.target.name;
        this.setState({
            ...this.state,
            fields: {
                ...this.state.fields,
                [name]: e.target.value,
                [name + "Touched"]: true
            }
        })
    };

    clearErrors() {
        this.setState({
            ...this.state,
            errors: {}
        })
    };


    openPrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: true
        });
    };

    closePrivacyPolicy = () => {
        this.setState({
            ...this.state,
            privacyPolicyOpened: false
        });
    };

    openTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: true
        });
    };

    closeTermsOfService = () => {
        this.setState({
            ...this.state,
            termsOfServiceOpened: false
        });
    };

    canApplyCoupon() {
        return this.props.premium.history.filter((premium) => premium.order_status === "PAID").length === 0;
    }

    setCouponCode(e) {
        if (this.canApplyCoupon()) {
            const value = e.target.value.slice(0, 35).toUpperCase();

            this.setState({
                ...this.state,
                coupon: {
                    ...this.state.coupon,
                    code: value
                }
            });
        }
    }

    isCouponInvalid() {
        if (this.state.coupon.errors !== null) {
            return Object.values(this.state.coupon.errors)[0];
        }
        return false;
    }

    formatPrice(price) {
        //price = Math.round(price * 100) / 100;
        return price.toFixed(2);
    }

    applyCoupon() {
        if (this.canApplyCoupon()) {
            this.props.checkCouponCode(this.state.coupon.code, this.state.duration)
                .then(res => {
                    this.setState({
                        ...this.state,
                        coupon: {
                            ...this.state.coupon,
                            type: res.data.type,
                            value: res.data.value,
                            errors: null
                        }
                    });
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        coupon: {
                            ...this.state.coupon,
                            type: null,
                            value: null,
                            errors: err.response.data.errors
                        }
                    });

                });
        }
    }

    resetCoupon() {
        this.setState({
            ...this.state,
            coupon: {
                code: "",
                type: null,
                value: null,
                errors: []
            }
        });
    }

    setIframeRef(iframe) {
        if (iframe) {
            iframe.onload = () => {
                this.setState({
                    ...this.state,
                    iframe_white_block_visible: true
                });
            }
        }
    }


    closeTrustpayDialog() {
        this.setState({
            ...this.state,
            iframe_url: null
        });
        this.props.get_premium_history();
        this.props.history.push("/premium");

    }

    onTrustpayMessage(message) {
        if (message.origin === "https://amapi.trustpay.eu") { // lepsie by bolo contains trustpay.eu ale neefektivnejsie
            if (message.data.func === "closePopup") {
                this.closeTrustpayDialog();
            }
        }
    }

    render() {
        if (this.state.redirect_url) {
            this.props.history.push(this.state.redirect_url);
            return <LinearProgress/>
        }
        if (this.props.premium.history.filter((premium) =>
            (new Date(premium.start)).getTime() > (new Date()).getTime() && premium.order_status === "PAID"
        ).length > 0) {
            this.props.history.push('/premium');
            return <LinearProgress/>
        }
        const {classes} = this.props;
        if (this.props.premium.history === null) {
            return <LinearProgress/>
        }

        // const selected_plan = this.state.duration === 30 ? "Month" : "Year";
        // const selected_plan_price = this.state.duration === 30 ? "1.99" : "19.90";
        const selected_plan = this.state.tier === "lite" ? "Lite" : "Great";
        //const selected_plan_price = this.state.tier === "lite" ? "1.99" : "19.90";
        const selected_plan_price = this.state.tier === "lite" ? "79.95" : "99.95";

        let errors;
        if (this.state.errors && Object.keys(this.state.errors).length > 0) {
            let errors_array = [];
            Object.keys(this.state.errors).map((field) => {
                errors_array.push(this.state.errors[field]);
            });
            errors = (
                <Grid item xs={12} sm={12}>
                    <SnackbarMessage onClose={this.clearErrors.bind(this)} type="error"
                                     message={errors_array.join(", ")} autoHideDuration={null} anchorOrigin={false}
                                     style={{marginBottom: 15}}/>
                </Grid>
            )
        } else {
            errors = false
        }

        const total_price = this.state.coupon.type === null ?
            selected_plan_price
            :
            (
                this.state.coupon.type === "fixed"
                    ?
                    this.formatPrice(selected_plan_price - clamp(this.state.coupon.value, 0, selected_plan_price))
                    :
                    this.formatPrice(selected_plan_price * (1 - (clamp(this.state.coupon.value, 0, 100) / 100)))
            );


        return (
            <Box className={classes.root}>
                {this.state.iframe_url && <Modal open={true} onClose={() => this.closeTrustpayDialog()}>
                    <iframe ref={(r) => this.setIframeRef(r)} src={this.state.iframe_url} frameBorder="0"
                            style={{height: "100%", width: "100%"}}/>
                </Modal>}
                <PrivacyPolicy open={this.state.privacyPolicyOpened} closeHandle={this.closePrivacyPolicy}/>
                <TermsOfService open={this.state.termsOfServiceOpened} closeHandle={this.closeTermsOfService}/>
                <Button className={classes.backBtn} onClick={() => this.props.history.push("/premium")}
                        size="small"
                        startIcon={<ChevronLeftIcon/>}>
                    Back
                </Button>

                <Paper className={classes.paper} style={{background: this.props.theming.darkMode ? "black" : "white"}}>
                    <Grid container
                          spacing={2}>
                        <Grid item xs={12} md={7} lg={8}>
                            <Typography variant={"h5"} gutterBottom={true}>Personal details</Typography>
                            <Grid
                                container
                                direction="row"
                                spacing={2}
                                style={{marginBottom: 15}}
                            >
                                {errors}
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard"
                                               fullWidth label="First name"
                                               type="text" value={this.state.fields.first_name}
                                               disabled
                                               className={classes.input}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard"
                                               fullWidth label="Last name"
                                               type="text" value={this.state.fields.last_name}
                                               disabled
                                               className={classes.input}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard"
                                               fullWidth label="E-mail"
                                               type="email" value={this.state.fields.email}
                                               disabled
                                               className={classes.input}
                                    />
                                </Grid>

                            </Grid>

                            <Typography variant={"h5"} gutterBottom={true}>Address</Typography>
                            <Grid
                                container
                                direction="row"
                                spacing={2}
                            >
                                <Grid item xs={12} sm={12}>
                                    <TextField variant="standard" fullWidth label="Street" required
                                               type="text"
                                               name="street"
                                               value={this.state.fields.street}
                                               className={classes.input}
                                               onChange={this.onFieldChange.bind(this)}
                                               error={Boolean(this.isStreetInvalid())}
                                               helperText={this.isStreetInvalid()}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard" fullWidth label="City" required
                                               type="text"
                                               name="city"
                                               value={this.state.fields.city}
                                               className={classes.input}
                                               onChange={this.onFieldChange.bind(this)}
                                               error={Boolean(this.isCityInvalid())}
                                               helperText={this.isCityInvalid()}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard" fullWidth label="Postal code" required
                                               type="text"
                                               name="postal_code"
                                               value={this.state.fields.postal_code}
                                               className={classes.input}
                                               onChange={this.onFieldChange.bind(this)}
                                               error={Boolean(this.isPostalCodeInvalid())}
                                               helperText={this.isPostalCodeInvalid()}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl variant="standard" className={classes.formControl}
                                                 style={{minWidth: 120}}
                                                 error={Boolean(this.isCountryInvalid())}>
                                        <InputLabel id="country">Country</InputLabel>
                                        <Select
                                            labelId="country"
                                            name="country"
                                            value={this.state.fields.country_code}
                                            onChange={this.onFieldChange.bind(this)}
                                            autoWidth
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            {//https://stefangabos.github.io/world_countries/
                                                countries.map((country) => <MenuItem key={country.alpha3}
                                                                                     value={country.alpha3.toUpperCase()}>
                                                    {country.name}
                                                </MenuItem>)}
                                        </Select>
                                        <FormHelperText>{this.isCountryInvalid()}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField variant="standard" fullWidth label="Phone number (optional)"
                                               type="text"
                                               name="phone_number"
                                               value={this.state.fields.phone_number}
                                               onChange={this.onFieldChange.bind(this)}
                                               error={Boolean(this.isPhoneNumberInvalid())}
                                               helperText={this.isPhoneNumberInvalid()}
                                               className={classes.input}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12}>
                                    <Typography variant="caption" className={classes.redirectInfo}>
                                        <LockIcon fontSize="small"/> Address will be stored for the invoicing only.
                                        <br/>
                                        <span className={classes.spanLink}
                                              onClick={this.openTermsOfService}>Terms of Service</span> and <span
                                        className={classes.spanLink}
                                        onClick={this.openPrivacyPolicy}>Privacy Policy</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={5} lg={4}>
                            <Typography variant="h5">Order</Typography>
                            <TableContainer style={{marginBottom: '18px'}}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" className={classes.font}>Item</TableCell>
                                            {/*<TableCell align="center" className={classes.font}>Duration</TableCell>*/}
                                            <TableCell align="center" className={classes.font}>Tier</TableCell>
                                            <TableCell align="center" className={classes.font}>Price</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="left" className={classes.font}>Premium</TableCell>
                                            <TableCell align="center"
                                                       className={classes.font}>{selected_plan}</TableCell>
                                            <TableCell align="center"
                                                       className={classes.font}>{selected_plan_price} €</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {this.canApplyCoupon() && <>
                                <Typography variant="h5" gutterBottom={true} style={{marginTop: 30}}>Coupon</Typography>
                                {this.state.coupon.value == null ?
                                    <Grid container>
                                        <Grid item xs={9} sm={6} md={9}>
                                            <TextField variant="standard" label="Code" required
                                                       fullWidth
                                                       type="text"
                                                       name="coupon_code"
                                                       value={this.state.coupon.code}
                                                       onChange={this.setCouponCode.bind(this)}
                                                       error={Boolean(this.isCouponInvalid())}
                                                       helperText={this.isCouponInvalid()}
                                                       className={classes.input}
                                                       autoComplete="off"
                                            />
                                        </Grid>
                                        <Grid item xs={3} sm={6} md={3} style={{
                                            display: "flex",
                                            alignItems: "center",
                                            alignContent: "center",
                                            justifyContent: "center"
                                        }}>
                                            <Button
                                                //startIcon={<CheckIcon/>}
                                                size={"small"}
                                                variant="contained" color="primary"
                                                disabled={this.state.coupon.code.length < 5 || this.state.coupon.code.length > 35}
                                                onClick={this.applyCoupon.bind(this)}
                                            >
                                                Apply
                                            </Button>
                                        </Grid>
                                    </Grid> : <Grid container alignItems={"center"}>
                                        <Grid item xs={6}><Typography>{this.state.coupon.code}</Typography></Grid>
                                        <Grid item xs={6}
                                              style={{textAlign: "right"}}>
                                            <Typography>
                                                {this.state.coupon.type === "fixed" ? <>
                                                    -{clamp(this.state.coupon.value, 0, selected_plan_price)} €
                                                </> : <>
                                                    -{clamp(this.state.coupon.value, 0, 100)}%
                                                </>}

                                                <IconButton
                                                    size={"small"}
                                                    variant="contained" color="primary"
                                                    onClick={this.resetCoupon.bind(this)}
                                                >
                                                    <ClearIcon/>
                                                </IconButton>
                                            </Typography>
                                        </Grid>
                                    </Grid>}
                            </>}
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                className={classes.payButton}
                                alignItems="center"
                            >
                                <div style={{flexGrow: 1}}>
                                    <Typography className={classes.no_vat}><sup>*</sup>No VAT registration</Typography>
                                    <Typography className={classes.no_vat}><sup>*</sup>Payment via Secure Payment
                                        Gateway</Typography>
                                </div>
                                <div className={classes.pay_logos}>
                                    <img src={visa} alt="" className={classes.pay_logo}/>
                                    <img src={verified_by_visa} alt="" className={classes.pay_logo}/>


                                    <img src={mastercard_secure} alt="" className={classes.pay_logo}/>


                                    <img src={mastercard_ele} alt="" className={classes.pay_logo}/>


                                    <img src={mastercard} alt="" className={classes.pay_logo}/>
                                    <img src={maestro} alt="" className={classes.pay_logo}/>


                                    <img src={electron} alt="" className={classes.pay_logo}/>
                                </div>

                                <div className={classes.buttonProgressContainer}>
                                    <Button
                                        startIcon={<ShoppingCart/>}
                                        variant="contained" color="primary"
                                        size="large"
                                        disabled={this.state.pay_clicked || this.state.iframe_url}
                                        onClick={this.purchase.bind(this)}>
                                        {(total_price > 0 ? "Pay " + total_price + " €" : "Activate premium")}
                                    </Button>
                                    {this.state.pay_clicked && !this.state.iframe_url &&
                                        <CircularProgress size={20} className={classes.buttonProgress}/>}
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        );
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    premium: state.premium,
    theming: state.theming,
    is_logged: state.auth.is_logged
});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {get_premium_history, purchase_premium, checkCouponCode}
)(Premium)));
